// @ts-nocheck
import getCanOrderSample from "@store/Framework/Common/Utilities/samples/getCanOrderSample";
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

const useCanOrderSample = convertSelectorToHook(getCanOrderSample);

export default useCanOrderSample;
